import { Tag } from 'antd'

import {
  DAO_ASSET_STATUS_CONFIG,
  DAO_PROPOSAL_STATUS_CONFIG,
  DaoAssetStatusEnum,
  DaoProposalStatusEnum,
} from 'constants/dao-voting'

export const AssetStatusTag = ({ status }: { status?: DaoAssetStatusEnum }) => {
  const config = status ? DAO_ASSET_STATUS_CONFIG[status] : null
  if (!config) return <>--</>
  return <Tag color={config.color}>{config.label}</Tag>
}

export const ProposalStatusTag = ({ status }: { status?: DaoProposalStatusEnum }) => {
  const config = status ? DAO_PROPOSAL_STATUS_CONFIG[status] : null
  if (!config) return <>--</>
  return <Tag color={config.color}>{config.label}</Tag>
}
